import { render, staticRenderFns } from "./addPoint.vue?vue&type=template&id=3fa4e67b"
import script from "./addPoint.vue?vue&type=script&lang=js"
export * from "./addPoint.vue?vue&type=script&lang=js"
import style0 from "./addPoint.vue?vue&type=style&index=0&id=3fa4e67b&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\java\\project\\fenxijunya-java\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fa4e67b')) {
      api.createRecord('3fa4e67b', component.options)
    } else {
      api.reload('3fa4e67b', component.options)
    }
    module.hot.accept("./addPoint.vue?vue&type=template&id=3fa4e67b", function () {
      api.rerender('3fa4e67b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/merchant/deliveryAddress/addPoint.vue"
export default component.exports